import React from 'react';
import {Route, Link} from 'react-router-dom';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';
import routes from '../../routes';

const findRouteName = (url) => {
    return routes[url];
};

const getPaths = (pathname) => {
    const paths = ['/'];

    if (pathname === '/') return paths;

    pathname.split('/').reduce((prev, curr, index) => {
        const currPath = `${prev}/${curr}`;
        paths.push(currPath);
        return currPath;
    });
    return paths;
};

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const BreadcrumbsItem = ({...rest,location : {search}, match}) => {
    const routeName = findRouteName(match.url);
    //console.log(search);
    //console.log(siteName + ' - sdadsdsdas');
    const urlSplit = match.url.split('/');
    const siteName = urlSplit[urlSplit.length - 1].replace('+',' ');
    //console.log('rest.location: ' + rest.location.pathname);
    //console.log('match.url:     ' + match.url);
    let isLocTrue = rest.location.pathname.toString() === match.url.toString();
    //console.log('== ' + routeName);
    //console.log(siteName);
    //console.log(match.url);
    if (!siteName.includes('device_')) {
        return (
            isLocTrue ?
                (
                    <BreadcrumbItem active>{capitalizeFirstLetter(siteName)}</BreadcrumbItem>
                ) :
                (
                    <BreadcrumbItem>
                            {routeName}
                    </BreadcrumbItem>
                )
        );
    }
    return null;
};


const Breadcrumbs = ({...rest, location : {pathname}, match}) => {
    const paths = getPaths(pathname);
    const items = paths.map((path, i) => <Route key={i++} path={path} component={BreadcrumbsItem}/>);
    return (
        <Breadcrumb>
            {items}
        </Breadcrumb>
    );
};

export default props => (
    <div>
        <Route path="/:path" component={Breadcrumbs} {...props} />
    </div>
);







// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js